import { TableCell, TableRow } from 'design-system';

import type { ExtendedSeriesOptionsType } from '@/features/charts/types/highcharts';

const LegendItem = ({ series }: { series: ExtendedSeriesOptionsType }) => {
  const context = series?.custom;
  if (!context) return null;
  return (
    <TableRow
      key={series.name + context.field}
      className='border-b border-gx-neutral align-middle last:border-b-0'
    >
      <TableCell className='pr-10 text-sm'>{context.Title}</TableCell>
      <TableCell className='w-[110px] pr-10 text-left text-sm'>{context.Alias}</TableCell>
      <TableCell className='w-[110px] pr-10 text-left text-sm'>{context.Code}</TableCell>
      <TableCell className='w-20 pr-10 text-right text-sm'>{context.Currency}</TableCell>
      <TableCell className='w-20 text-right text-sm'>{context.Units}</TableCell>
    </TableRow>
  );
};

export default LegendItem;
